import React from "react";
import _ from "lodash";

// Input component
export const Input = React.forwardRef(
    (
        {
            label,
            id,
            name,
            type = "text",
            placeholder = "",
            disabled = false,
            required = false,
            isHideLabel = false,
            className = "",
            subTitle = "",
            subRequired = false,
            errors = null,
            errorName = "",
            ...props
        },
        ref
    ) => {
        const msg = _.get(errors || {}, errorName || name);
        const InputComponent = type === "textarea" ? 'textarea' : "input"
        return (
            <div className="w-full font-urbanist">
                {((!!label && !isHideLabel) || !isHideLabel) && (
                    <label
                        htmlFor={id}
                        className={`block text-lg font-semibold mb-1 ${disabled ? "text-gray-500" : "text-white"}`}
                    >
                        {label} {required && <span className="text-red-600">*</span>}
                    </label>
                )}
                {
                    !!subTitle &&
                    <p className="text-xs text-gray-400 mb-1">
                        {subTitle}
                        {subRequired && <span className="text-red-600">*</span>}
                    </p>
                }
                <InputComponent
                    ref={ref}
                    id={id}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    className={`bg-[#22262E] border border-gray-700 rounded-lg w-full py-2 px-3 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-white ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-400"
                        } ${className}`}
                    {...props}
                />
                {
                    !!msg &&
                    <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>
                }
            </div>
        )
    }
);
